export enum CUSTOM_ERROR_KEYS {
	GLOBAL_ERROR = 'GLOBAL_ERROR',
}
